import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import arrowLeft from "../assets/images/navbar/arrow-left.png";
import { staticContentService, StaticPageSlug } from "../services";

interface StaticContentPageProps {
  slug: StaticPageSlug;
  title: string;
}

const StaticContentPage = ({ slug, title }: StaticContentPageProps) => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchContent = async () => {
      setLoading(true);
      setError("");
      try {
        const res: any = await staticContentService.getStaticPage(slug);
        if (res.status && res.data?.content) {
          setContent(res.data.content);
        } else {
          setError(res.message || `Unable to load ${title.toLowerCase()}`);
        }
      } catch (err: any) {
        setError(err?.message || `Unable to load ${title.toLowerCase()}`);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, [slug, title]);

  return (
    <div className="bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300 mt-[7.5rem] md:mt-[72px]">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="w-10 h-10 flex items-center justify-center"
            aria-label="Go back"
          >
            <img src={arrowLeft} alt="back" className="w-6 h-6 dark:invert" />
          </button>
          <h1 className="text-[#050505] dark:text-white font-urbanist text-[22px] font-semibold">
            {title}
          </h1>
        </div>

        <div className="rounded-[16px] border dark:border-gray-700 bg-white dark:bg-gray-800 p-6">
          {loading ? (
            <p className="text-center text-gray-500 dark:text-gray-400 py-10">
              Loading...
            </p>
          ) : error ? (
            <p className="text-center text-red-500 py-10">{error}</p>
          ) : (
            <div
              className="prose dark:prose-invert max-w-none text-[#050505] dark:text-gray-200 font-urbanist"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StaticContentPage;
